import { render } from "./BrowseCard.vue?vue&type=template&id=f35c51be&scoped=true"
import script from "./BrowseCard.vue?vue&type=script&lang=js"
export * from "./BrowseCard.vue?vue&type=script&lang=js"

import "./BrowseCard.vue?vue&type=style&index=0&id=f35c51be&lang=sass&scoped=true"
import "./BrowseCard.vue?vue&type=style&index=1&id=f35c51be&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35c51be"]])

export default __exports__